import React from 'react';

const services = [
  {
    id: 'indoor',
    name: 'Indoor Sessions',
    text: 'Intimate indoor photography with beautiful natural window lighting. Perfect for capturing family bonds in a cozy, comfortable setting.'
  },
  {
    id: 'outdoor',
    name: 'Outdoor Sessions',
    text: "Stunning outdoor photography at beaches, parks, and scenic locations. Capture your family's joy in beautiful natural settings."
  },
  {
    id: 'studio',
    name: 'Studio Sessions',
    text: 'Professional studio photography with controlled lighting. Timeless portraits with a classic, polished aesthetic.'
  }
];

export const ServicesOverview = ({ onViewGallery }) => (
  <section className="section-spacing bg-[#1a1a1a]" data-testid="about-services">
    <div className="revolt-container">
      <div className="text-center mb-lg">
        <h2 className="section-title">What We Offer</h2>
        <p className="subtitle max-w-2xl mx-auto">
          Professional family photography services tailored to your needs
        </p>
      </div>

      <div className="packages-grid">
        {services.map((service, index) => (
          <div key={service.id} className={`package-card fade-in-up ${index ? `stagger-${index}` : ''}`}>
            <h3 className="package-name">{service.name}</h3>
            <p className="text-[#b8b8b8] mb-6">{service.text}</p>
            <button
              onClick={() => onViewGallery(service.id)}
              className="hero-cta"
              style={{ padding: '0.8rem 2rem', fontSize: '0.75rem' }}
              data-testid={`about-view-gallery-${service.id}`}
            >
              View Gallery
            </button>
          </div>
        ))}
      </div>
    </div>
  </section>
);
